import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
// import { selectCurrentDeviceStatus } from 'src/app/store/device/device.selector';

@Component({
	selector: 'app-gweth-fw-update-dialog',
	templateUrl: './gweth-fw-update.dialog.component.html',
})
export class GwethFwUpdateDialogComponent implements OnInit, OnDestroy {
	// TODO: re-enable firmware progress percentage (event 94 / DeviceStatus.Percentage)
	// percentage: number | undefined;
	private statusSub: Subscription | undefined;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
	) { }

	ngOnInit(): void {
		// this.statusSub = this.store.select(selectCurrentDeviceStatus).subscribe(status => {
		// 	this.percentage = status?.Percentage;
		// });
	}

	ngOnDestroy(): void {
		this.statusSub?.unsubscribe();
	}

	backToDevices(): void {
		this.ref.close(true);
	}
}
